// AUTO-GENERATED by bin/extract_legal_docs.py — do not edit by hand.
// Source: recording_consent.md (canonical markdown)
// Generated text hash (sha256): b19d7dd6ee44405467afbcae37472809f1dc8cf8ef81328068b9ba53ac8c2702

const content = `XPERT.COMPANY

operating xpert.company

Recording & AI Consent Notice

How we treat session recording, transcription and AI-generated outputs

Version 1.1 · Effective 8 July 2026 · Issued by the Office of the Chief Legal & Compliance Officer (CLCO)

# 1. Purpose

This Notice describes how xpert.company handles session recordings, AI-generated transcripts, and AI-generated summaries. It is given to you before you enter a session and surfaced as a persistent banner during the session. By proceeding with recording you provide express consent under applicable law.

# 2. Pre-call consent screen

Before any session begins, every participant sees the following screen. The session cannot be recorded unless every participant explicitly opts in. If any participant declines, the session proceeds without recording, transcription, or AI summaries; the meeting still happens.

Sample text shown to participants:

"This session can be recorded, transcribed and summarised by AI for the participants' future reference. Recordings and transcripts are stored for 90 days by default and can be deleted on request. AI summaries are generated by a language model and may be inaccurate; do not rely on them for important decisions. Do you consent to recording, transcription and AI summarisation? You can change your mind at any time during the session."

Three buttons: "Yes, record, transcribe and summarise." / "No, do not record." / "Audio only — record but do not transcribe or summarise."

Each participant's choice, and the time they made it, is recorded so that consent can be evidenced.

# 3. In-call indicators

A red "REC" indicator and a banner stating "This call is being recorded and transcribed" remain visible for every participant throughout the call when recording is on.

Any participant can press "Stop recording" to end the recording for everyone, immediately, no questions asked.

If a new participant joins, the call automatically pauses recording until the new participant has been shown the consent screen and accepted.

# 4. Jurisdiction notes

United States (California, Florida, Illinois, Maryland, Massachusetts, Montana, Nevada, New Hampshire, Pennsylvania, Washington and other all-party-consent states): consent must be given by every participant. We apply this rule uniformly across the United States to remove ambiguity.

United Arab Emirates: recording any private conversation without consent is a criminal offence under Article 431 of the UAE Penal Code (Federal Decree-Law No. 31 of 2021). Our consent UX is structured to satisfy this requirement.

European Union and United Kingdom: recording requires a valid lawful basis under GDPR/UK GDPR. We rely on consent, which can be withdrawn at any time. Withdrawing consent stops future recording and processing; it does not by itself require deletion of a recording already lawfully made, though you may separately request deletion under Section 5.

India: recording requires consent under the DPDPA and the relevant evidentiary rules; we capture explicit consent.

# 5. Storage and retention

Recordings and transcripts are stored for 90 days by default.

Either participant can extend storage up to 365 days at the time of the session (a small fee may apply).

Either participant can request immediate deletion at any time, with effect across both accounts.

Because deletion takes effect for both participants, we retain a minimal, access-logged record that a session occurred and that a deletion was requested (not its content), for dispute-resolution and audit purposes only.

# 6. AI processing

Transcripts are generated using Daily.co's built-in transcription, with OpenAI Whisper as a fallback. Where AI-generated summaries are offered, they are produced by a large language model provider engaged under a zero-retention agreement; the current provider is identified in our sub-processor list at xpert.company/subprocessors. Our transcription and summary providers are contractually bound not to use your data to train their models and to delete it after processing. Outputs are made available to the participants in the session and are not shared with anyone else without further consent.

# 7. Your rights

You may at any time access the recording or transcript via your account dashboard, delete it (the deletion takes effect for both participants), or request portability (download in MP4/WebM and TXT formats). You may withdraw consent for future sessions through your privacy settings or by emailing privacy@xpert.company.

# 8. Exceptions

We will not access a recording or transcript except: (a) at the participants' request, (b) to comply with a valid legal process, (c) to investigate a credible safety or abuse report (with a documented case file), or (d) to address a security incident affecting the recording. Every access of this kind is logged and reviewable on request.
`;

export default content;
